import React from "react";
import SteppedGuide from "web/react/components/step-guide/step-guide";
import HomepageBusinessValue from "web/react/components/homepage-business-value/homepage-business-value";
import HomepageDesignerRail from "web/react/components/homepage-designer-rail/homepage-designer-rail";
import HomepageGenericTypes from "web/react/components/homepage-generic-types/homepage-generic-types";
import HomepageProductRail from "web/react/components/homepage-product-rail/homepage-product-rail";
import HomepageStoreRail from "web/react/components/homepage-store-rail/homepage-store-rail";
import HomepageTrendRail from "web/react/components/homepage-trend-rail/homepage-trend-rail";
import FeaturedBanners from "web/react/components/featured-banners/featured-banners";
import styles from "./classic-homepage-layout.css";

interface HomepageLayoutProps {
    layoutData: any;
}

export function HomepageLayout({
    layoutData: {
        homepage_popular_products: popularProducts,
        homepage_stores: stores,
        homepage_designers: designers,
        homepage_designer_categories: designerCategories,
        homepage_trends: trends,
        homepage_business: business,
        homepage_brand_values: brandValues,
        homepage_generic_types: genericTypes,
        homepage_featured_banners: homepageFeaturedBanners,
    },
}: HomepageLayoutProps): JSX.Element {
    const hasDesignerRails = designers || designerCategories;

    return (
        <>
            {popularProducts && (
                <HomepageProductRail
                    title={popularProducts.title}
                    products={popularProducts.products}
                />
            )}

            {stores && <HomepageStoreRail stores={stores.links} />}

            {homepageFeaturedBanners && <FeaturedBanners {...homepageFeaturedBanners} />}

            {business && <HomepageBusinessValue sections={business.modules} />}

            {brandValues && <SteppedGuide {...brandValues} />}

            {hasDesignerRails && (
                <div className={styles.designerSection}>
                    <h2 className={styles.designerTitle}>{designers.section_title}</h2>

                    {designers && <HomepageDesignerRail items={designers.links} />}

                    {designerCategories && (
                        <HomepageDesignerRail
                            items={designerCategories.links}
                            type="DESIGNER_CATEGORY"
                        />
                    )}
                </div>
            )}

            {trends && (
                <HomepageTrendRail
                    sectionTitle={trends.section_title}
                    mensLinks={trends.mens_links}
                    womensLinks={trends.womens_links}
                />
            )}

            {genericTypes && <HomepageGenericTypes genericTypes={genericTypes} />}
        </>
    );
}

export default HomepageLayout;
